import React, { Component } from "react";
import * as ajax from "helpers/ajax";
import { UPLOAD_PATH } from "constant.js";
import DataTable from "examples/Tables/DataTable/index.js";

import DataTableModal from "./dataTableModal.js";
import Filters from "./filters.js";

import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon"

import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

import defaultUser from 'assets/images/default-user.png';

import { withSnackbar } from 'notistack';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import {noteInline, toPrice, calculateMarkup, toEuropeanDate, calculateImportoContrattuale } from "helpers/functions.js"
import { calcolaDifferenzaTempo, combineDateAndTime, commessaName, DipendenteOrConsulenteName, missingHours, operaioFullName } from "../../helpers/functions.js";


export class MyDataTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            openDeleteDialog: false,
            deleteId: null,
            currentPage:0,
            filters:{},
            filterString:{},
            loading:true,
        };
        this.modal = null;
        this.filterString="";
    }

    componentDidMount = () => {
        if(this.props.customData){
        this.setState({ data: this.props.customData,loading:false })
        }else{
        this.loadData()
        }
    };

    loadData = () => {
        let additionalFilters="";
        for (const [key, value] of Object.entries(this.state.filterString)) {
            additionalFilters+=value;
        }



        this.filterString = this.props.tableData.route + "?" + (this.props.defaultSort ? this.props.defaultSort : "sort=id") +"&populate=*"+(this.props.filters?this.props.filters:"")+additionalFilters;
        ajax.ajaxGetStrapi(this.filterString, this.apiCallback);
        
        this.downloadAllRefs()
    }

    setFilter=(val,key,stringFilter)=>{
        let temp=this.state.filters;
        temp[key]=val;

        let s=this.state.filterString;
        s[key]=stringFilter
        
        this.setState({filters:temp,filterString:s,loading:true},this.loadData)
    }

    apiCallback = (response) => {
        if (this.props.tableData.noDataWrapper) {
            this.setState({ data: response })
            return;
        }

        this.setState({ data: response.data,loading:false })
    }

    downloadAllRefs = () => {
        this.props.tableData.fields.map((el, index) => {
            if (el.type == "ref") {
                this.props.tableData.fields[index].values = [];
                ajax.ajaxGetStrapiRef(el.path, this.downloadAllRefsCallback,index);
            }
        })
    }

    downloadAllRefsCallback = (response, index) => {
        this.props.tableData.fields[index].values = response.data;
    }

    colAlign = (col) => {
        if (col.type == "boolean" || col.type == "boolean reverse" || col.type == "avatar") {
            return "center"
        }
        return "left"
    }

    colWidth = (col) => {
        if (col.type == "boolean" || col.type == "boolean reverse" || col.type == "avatar") {
            return "0%"
        }
        return "auto"
    }

    columns = () => {
        let arr = [];
        this.props.tableData.columns.map((col, indexCol) => {
            if (col.permission) {
                if (!col.permission.includes(global.user.ruolo)) {
                    return null
                }
            }

            arr.push({ Header: col.label, accessor: col.name, sortable: col.sorted, align: this.colAlign(col), width: this.colWidth(col), filterType:col.filterType});
        })
        if (this.props.edit || this.props.delete || this.props.customAction.length>0) {
            arr.push({ Header: "Azioni", accessor: "Azioni" });
        }
        return arr;
    }

    rows = () => {
        let arr = [];
        this.state.data.map((row, IndexRow) => {
            let obj = {};
            this.props.tableData.columns.map((col, indexCol) => {
                switch (col.type) {
                    case "text": obj[col.name] = row[col.name]; break;
                    case "text-container": obj[col.name] = (<MDBox style={{maxWidth:400, maxHeight:100, overflowY:"auto"}}>{row[col.name]}</MDBox>); break;
                    case "boolean": obj[col.name] = (row[col.name]) ?
                        (
                            <MDAvatar bgColor="error" size="xs">
                                <Icon fontSize="small">close</Icon>
                            </MDAvatar>
                        ) :
                        (
                            <MDAvatar bgColor="success" size="xs">
                                <Icon fontSize="small">done</Icon>
                            </MDAvatar>
                        );
                        break;
                    case "boolean reverse": obj[col.name] = (row[col.name]) ?
                        (
                            <MDAvatar bgColor="success" size="xs">
                                <Icon fontSize="small">done</Icon>
                            </MDAvatar>
                        ) :
                        (
                            <MDAvatar bgColor="error" size="xs">
                                <Icon fontSize="small">close</Icon>
                            </MDAvatar>
                        );
                        break;
                    case "avatar":
                        obj[col.name] = (<MDAvatar src={UPLOAD_PATH + "/file/" + col['path'] + "/" + row['id'] + ".png?"+Date.now()} alt="Avatar" size="sm" > <img style={{ width: "100%", height:"100%"}} src={defaultUser}/> </MDAvatar>);
                        break;
                    case "decimal":
                        obj[col.name] = toPrice(parseFloat(row[col.name]).toFixed(2));
                        break;
                    case "function":
                        switch (col.functionID) {
                            case 1: return obj[col.name] = calculateMarkup(row)
                            case 2: return obj[col.name] = calculateImportoContrattuale(row)
                            case 3: return obj[col.name] = combineDateAndTime(row.data_assegnazione, row.ora_assegnazione)
                            case 4: return obj[col.name] = combineDateAndTime(row.data_consegna, row.ora_consegna)
                            case 5: return obj[col.name] = DipendenteOrConsulenteName(row)
                            case 6: return obj[col.name] = calcolaDifferenzaTempo(row.data_assegnazione, row.ora_assegnazione, row.data_consegna, row.ora_consegna)
                            case 7: return obj[col.name] = operaioFullName(row);
                            case 8: return obj[col.name] = commessaName(row);
                            case 9: return obj[col.name] = missingHours(row);
                            case 10: return obj[col.name] = noteInline(row);

                            default: obj[col.name] = row[col.name];
                        }
                        break;
                    case "date":
                        obj[col.name] = toEuropeanDate(row[col.name]);
                        break;
                    default: obj[col.name] = row[col.name];
                }
                if (col.append) {
                    obj[col.name] = obj[col.name] + col.append
                }
            });


           if (this.props.edit || this.props.delete || this.props.customAction.length > 0) {
                const canEdit = !this.props.editCondition || this.props.editCondition(row);
                
                obj["Azioni"] = (
                    <MDBox>
                        <Grid container spacing={1}>
                            {(this.props.customAction.map((el, index) => {
                                return (
                                    <Grid item key={"custom-action-" + index}>
                                        <MDButton color={el.color ? el.color : "success"} iconOnly onClick={() => el.function(row)}>
                                            <Icon>{el.icon ? el.icon : "default"}</Icon>
                                        </MDButton>
                                    </Grid>
                                )
                            }))}

                            {(this.props.edit) ? (
                                <Grid item>
                                    <MDButton color="warning" iconOnly disabled={!canEdit} onClick={() => this.edit(row)}>
                                        <Icon>edit</Icon>
                                    </MDButton>
                                </Grid>
                            )
                                : null
                            }
                            {(this.props.delete) ? (
                                <Grid item>
                                    <MDButton color="error" iconOnly onClick={()=>this.deleteRow(row["id"])}>
                                        <Icon>deleteForever</Icon>
                                    </MDButton>
                                </Grid>
                            )
                                : null
                            }
                        </Grid>
                    </MDBox>
                )
            }
            arr.push(obj);
        })

        return arr;
    }

    successCallback = (msg) => {
        this.loadData();
        this.props.enqueueSnackbar(msg, {
            variant: "success",
            anchorOrigin: { horizontal: "right", vertical: "top" }
        })
    }

    errorRef = (msg) => {
        this.props.enqueueSnackbar(msg, {
            variant: "error",
            anchorOrigin: { horizontal: "right", vertical: "top" }
        })
    }

    deleteRow = (id) => {
        this.setState({openDeleteDialog:true, deleteId:id})
    }

    deleteCallback = (response) => {
        if (response.id) {
            this.props.enqueueSnackbar(this.props.tableData.deletedLabel, {
                variant: "error",
                anchorOrigin: { horizontal: "right", vertical: "top" }
            })
        }


        this.setState({ deleteId: null, openDeleteDialog: false }, this.loadData)

        if (this.props.onDelete) {
            this.props.onDelete(response)
        }

    }

    edit = (data) => {
        this.modal.openModal(true, data, true)
    }

    render() {

        return (
            <>
            <Filters data={this.props.tableData} filters={this.state.filters} setFilter={this.setFilter} loading={this.state.loading}/>
                <MDBox>
                    {(this.props.add) ?
                        <MDBox py={3}>
                            <Grid item sm={12} md={4}>
                                <MDButton fullWidth color="success" onClick={() => this.modal.openModal(true)}>
                                    <Icon style={{ marginRight: 10 }}>add</Icon>
                                    {this.props.tableData.addLabel}
                                </MDButton>
                            </Grid>
                        </MDBox>
                        : null
                    }
                    <Grid>
                        <DataTable
                            table={{
                                columns: this.columns(),
                                rows: this.rows()
                            }}
                            canSearch={true}
                            afterSearch={() => null}
                            showTotalEntries={false}
                            //currentPage={this.state.currentPage}
                            //onPageChange={(n) => { this.setState({currentPage:n}) }}
                            onPageChange={() => null}
                            filterString={this.filterString}
                        />
                    </Grid>
                </MDBox>
                <DataTableModal
                    tableData={this.props.tableData}
                    ref={(ref) => this.modal = ref}
                    successCallback={(msg) => this.successCallback(msg)}
                    onDelete={this.props.onDelete}
                    onEdit={this.props.onEdit}
                    onBeforeEdit={this.props.onBeforeEdit}
                    onNew={this.props.onNew}
                    newRawData={this.props.newRawData}
                    commessaID={this.props.commessaID}
                    hiddenID={this.props.hiddenID}
                />

                <Dialog
                    open={this.state.openDeleteDialog}
                    onClose={() => this.setState({ openDeleteDialog:false})}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {this.props.tableData.deleteLabel}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Una volta eliminato non sara' piu' possibile recuperarlo. 
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => ajax.ajaxDeleteStrapi(this.props.tableData.route+"/"+this.state.deleteId, this.deleteCallback)}>Elimina</Button>
                        <Button onClick={() => this.setState({deleteId:null, openDeleteDialog:false})} autoFocus>Annulla</Button>
                    </DialogActions>
                </Dialog>


            </>
        )
    }
}

export default withSnackbar(MyDataTable);


MyDataTable.defaultProps = {
    tableData: null,
    edit: false,
    add: false,
    delete:false,
    icon: null,
    customAction:[],
    editCondition: null
}
